import React, {useEffect, useState} from "react";
import {Button, Upload} from "antd";
import {Card, Input, message, Space, Table, Tag} from "antd";
import {TabButtons} from "./TabButtons";
import {
    getHostAddress,
    connectionBackend,
    setApiAddress,
    setJsonData,
    getDataReturned,
    mainSet
} from "../../Tool/UtileFun"
import {UploadOutlined} from "@ant-design/icons";

export function ClassTable(){

    useEffect(
        ()=>{
            findAll()
            //findAllUntil()
        },[]
    );



    const findAllUntil = ()=>{
        let value = {
            address:"/cclass/findAll",
            json:{}
        }
       setCClass(mainSet(value))
    }



    const findAll=()=>{
        fetch(
            "http://"+getHostAddress()+"/cclass/findAll",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify("{}"),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setCClass(data)
                console.log(data)
            })
            .catch(error => message.error("error"+error));
    }

    const searchClass=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/cclass/searchClassNew",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({name:value}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                setCClass(data)
                console.log("search-------")
                console.log(data)
            })
            .catch(error => message.error("error"+error));
    }

    const deleteClass=()=>{
        console.log(classId)
    }

    let classId = ""

    const buttons = () =>{
        return(
            <>
            <Button type="primary" >编辑</Button>
            <Button type="primary" danger onClick={deleteClass}>删除</Button>
            </>
        )
    }


    const [cClass,setCClass]=useState([]);

    const { Search } = Input;

    const columns = [
        {
            title: '序号',
            width:80,
            render:(text,record,index)=>`${index+1}`

        },
        {
            title: '班级名称',
            dataIndex: 'className',
            key: 'className',
        },
        {
            title: '操作',
            key: 'details',
            render: (classInfo) => (
                <>
                    <Space size="middle">
                        <TabButtons props = {classInfo}
                                    Event={()=>{
                                        findAll()
                                    }}
                        ></TabButtons>
                    </Space>
                </>
            ),
        },

    ];

    let data = []

    const propsData = {
        name: 'file',
        listType: 'video',
        action: "http://"+getHostAddress()+"/batchImportApi/importClass",
        headers: {
            authorization: 'authorization-text',
        },
        beforeUpload(file) {
            console.log(file.name)
            if (file.size > 1048576*500){
                message.info("上传文件最大支持500MB")
                return false
            }
            let fileName = file.name
            let format = ""
            let realFormat = ""
            for (let i = fileName.length - 1; i >= 0; i--) {
                console.log(fileName[i])
                if (fileName[i] === "."){
                    break
                }
                if (fileName[i] !== "."){
                    format = format + fileName[i]
                }
            }

            for (let i = format.length - 1 ; i >= 0 ; i--) {
                if (format[i] !=="."){
                    realFormat = realFormat + format[i]
                }
            }
            if (realFormat!=="xlsx"){
                message.info("仅支持xlsx格式的视频")
                return false
            }
            return true
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
                console.log("返回")
                console.log(info.file.response)
            }
            if (info.file.status === 'done' && info.file.response.state === 'success') {
                message.success(`${info.file.name} 文件上传成功`);
                findAll()
            } else if (info.file.status === 'error' && info.file.response.state === 'error') {
                message.error(`${info.file.name} 文件上传失败`);
            }
        },
    };

    return(
        <Card title={"班级管理"}>
            <Search placeholder="输入班级名称搜索"
                    onSearch={value => searchClass(value)}
                    enterButton
                    style={{width:500}}/>
            <Upload {...propsData}>
                <Button icon={<UploadOutlined />}>导入班级</Button>
            </Upload>
            <Table
                columns={columns}
                dataSource={cClass}
                pagination={{
                    onChange: page => {
                        console.log(page);
                    },
                    pageSize: 5,
                }}
            ></Table>
        </Card>
    )
}
